<template>
    <div>
        <v-card>
            <v-flex>
                <v-layout row justify-space-between>
                    <v-card-title class="headline pb-2">Students</v-card-title>
                    <!-- <v-card-actions>
                        <v-btn
                            class="text-xs-right"
                            small
                            color="success"
                            @click="resetPrice"
                            >Reset Price</v-btn
                        >
                    </v-card-actions> -->
                </v-layout>
            </v-flex>
            <v-divider></v-divider>
            <v-list three-line>
                <div v-for="(student, index) in students">
                    <v-list-tile class="pa-3">
                        <v-flex xs12>
                            <v-flex xs12 class="pl-0">
                                <v-layout row class="mb-0">
                                    <v-list-tile-title v-if="!student.nonUTA">
                                        {{ student.engName }}
                                        -
                                        {{ student.hebName }}
                                        ({{ student.class }})
                                    </v-list-tile-title>
                                    <v-list-tile-title v-else>
                                        <v-layout row class="pl-3 pt-2">
                                            <div>
                                                {{ student.engName }}
                                                -
                                                {{ student.hebName }}
                                                ({{ student.class }})
                                            </div>

                                            <div
                                                class="font-weight-medium ml-2 text-info"
                                            >
                                                Non UTA
                                            </div>
                                        </v-layout>
                                    </v-list-tile-title>
                                    <v-list-tile-action class="pa-0 ma-0">
                                        <v-layout row align-center>
                                            <v-btn
                                                v-if="student.nonUTA"
                                                small
                                                class="mr-3"
                                                @click="editStudent(student)"
                                                >edit student</v-btn
                                            >
                                            <v-spacer></v-spacer>
                                            <!-- <v-select
                                                hide-details
                                                class="pa-0 ma-0"
                                                :items="classes"
                                                label="Class"
                                                ref="chosenClass"
                                                v-model="student.chosenClass"
                                                :rules="[
                                                    (value) =>
                                                        rules.required(
                                                            value,
                                                            student.duration
                                                        ),
                                                ]"
                                                box
                                                item-text="`${data.item.grade} - ${data.item.teacher}`"
                                            >
                                                <template
                                                    slot="selection"
                                                    slot-scope="data"
                                                >
                                                    {{ data.item.grade }} -
                                                    {{ data.item.teacher }}
                                                </template>
                                                <template
                                                    slot="item"
                                                    slot-scope="data"
                                                >
                                                    <v-list-tile-content>
                                                        <v-list-tile-title
                                                            v-html="
                                                                `${
                                                                    data.item
                                                                        .grade
                                                                } - ${
                                                                    data.item
                                                                        .teacher
                                                                }`
                                                            "
                                                        >
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </template>
                                            </v-select> -->
                                        </v-layout>
                                    </v-list-tile-action>
                                </v-layout>
                            </v-flex>
                            <!-- <v-flex xs12 class="mb-1">
                                <v-layout row justify-space-between>
                                    <v-list-tile-action>
                                        <v-layout row>
                                            <div>
                                                <v-radio-group
                                                    @change="
                                                        updateTotal(
                                                            student,
                                                            true
                                                        )
                                                    "
                                                    v-model="student.duration"
                                                    row
                                                    hide-details
                                                >
                                                    <v-radio
                                                        class="py-2 pr-2"
                                                        label="Full"
                                                        value="FULL"
                                                        color="success"
                                                    ></v-radio>
                                                    <v-radio
                                                        class="pa-2"
                                                        label="First Half"
                                                        value="HALF 1"
                                                        color="success"
                                                    ></v-radio>
                                                    <v-radio
                                                        class="pa-2"
                                                        label="Second Half"
                                                        value="HALF 2"
                                                        color="success"
                                                    ></v-radio>
                                                    <v-radio
                                                        class="pa-2"
                                                        label="Custom"
                                                        value="CUSTOM"
                                                        color="success"
                                                    ></v-radio>
                                                    <v-radio
                                                        class="pa-2"
                                                        label="None"
                                                        value="NONE"
                                                        color="success"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </div>

                                            <v-spacer></v-spacer>
                                        </v-layout>
                                    </v-list-tile-action>
                                </v-layout>
                            </v-flex> -->
                            <v-layout
                                class="mt-4 mb-3"
                                row
                                justify-start
                                v-if="student.duration == 'CUSTOM'"
                            >
                                <v-checkbox
                                    class="ma-0 pa-0 weeks-selection"
                                    v-for="(week, index) in dates.map(
                                        (d) => d.parshe
                                    )"
                                    :key="week"
                                    :label="`${index + 1} ${week}`"
                                    value="1"
                                    color="success"
                                    @change="updateTotal(student, true)"
                                    v-model="
                                        student.explicitWeeks[
                                            getWeekProperty(index)
                                        ]
                                    "
                                ></v-checkbox>
                            </v-layout>
                            <v-layout row wrap class="pb-2">
                                <!-- <div v-if="!student.editingAmount">
                                    <v-layout row class="py-1 mt-3">
                                        <v-card-title
                                            class="py-0"
                                            style="background-color: #FFF; border-style: solid; border-color: #5cb860;"
                                        >
                                            <div class="font-weight-medium">
                                                ${{ getPaymentAmount(student) }}
                                            </div>
                                        </v-card-title>

                                        <v-card-actions class="py-0">
                                            <v-btn
                                                @click="edit(student)"
                                                flat
                                                icon
                                                class="text-xs-right"
                                                color="success"
                                            >
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </v-card-actions>
                                    </v-layout>
                                </div>
                                <div v-else>
                                    <v-layout row>
                                        <v-text-field
                                            class="mr-3"
                                            label="Amount"
                                            placeholder="Amount"
                                            v-model="student.paymentAmount"
                                            type="number"
                                            prefix="$"
                                            hide-details
                                        ></v-text-field>
                                        <v-btn
                                            class="mr-1"
                                            @click="() => rollback(student)"
                                            small
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            @click="
                                                student.editingAmount = false
                                            "
                                            small
                                            color="success"
                                        >
                                            save
                                        </v-btn>
                                    </v-layout>
                                </div> -->
                                <v-flex
                                    class="pl-0 pb-0"
                                    xs12
                                    sm6
                                    md2
                                    style="max-width: 200px;"
                                >
                                    <v-text-field
                                        @input="updateTotal(student)"
                                        hide-details
                                        v-model="student.paymentAmount"
                                        label="Camp Fee"
                                        prefix="$"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex
                                    style="max-width: 200px;"
                                    class="pl-0 pb-0"
                                    xs12
                                    sm6
                                    md2
                                    v-for="charge in student.charges"
                                >
                                    <v-text-field
                                        @input="updateTotal(student)"
                                        hide-details
                                        prefix="$"
                                        v-model="charge.paymentAmount"
                                        :label="charge.name"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex class="pl-0 pb-0" md2>
                                    <v-btn
                                        class="text-xs-right"
                                        small
                                        color="success"
                                        @click="resetPrice(student)"
                                        >Reset Price</v-btn
                                    >
                                </v-flex>
                            </v-layout>
                            <v-layout
                                row
                                justify-space-between
                                class="pl-2 mt-4 pt-2"
                            >
                                <!-- <v-layout
                                    row
                                    justify-start
                                    style="border: 2px solid #999; padding: 10px; padding-bottom: 0; max-width: 800px; border-radius: 4px;"
                                >
                                    <v-checkbox
                                        style="max-width: 175px;"
                                        v-model="student.lunchDoc"
                                        class="ml-2 mt-3 mb-0"
                                        label="Lunch Document"
                                        color="success"
                                        hide-details
                                    >
                                    </v-checkbox>
                                    <v-checkbox
                                        style="max-width: 150px"
                                        v-model="student.covidTest"
                                        class="ml-2 mt-3 mb-0"
                                        label="Covid Test"
                                        color="success"
                                        hide-details
                                    >
                                    </v-checkbox>

                                    <v-select
                                        style="max-width: 175px"
                                        class="mr-3"
                                        :items="
                                            insuranceCompanies.map(
                                                (c) => c.value
                                            )
                                        "
                                        label="Insurance Company"
                                        v-model="student.insuranceCompany"
                                    ></v-select
                                    ><v-text-field
                                        style="max-width: 175px"
                                        class="ml-2 mt-1 mb-2"
                                        v-model="student.insuranceID"
                                        label="Insurance ID"
                                    >
                                    </v-text-field>
                                </v-layout> -->
                                <v-layout
                                    row
                                    justify-end
                                    class="font-weight-medium headline text-success mt-4"
                                >
                                    <div class="pr-1">
                                        Total:
                                    </div>
                                    <div class="">
                                        {{ student.total | currency }}
                                    </div>
                                </v-layout>
                            </v-layout>
                        </v-flex>
                    </v-list-tile>
                    <v-divider v-if="index != students.length - 1" />
                </div>
            </v-list>
        </v-card>
        <v-dialog persistent v-model="newStudentDialog" max-width="400">
            <!-- <new-student
                ref="newStudent"
                :onCreated="onNewStudentCreated"
                :closeNewStudentModal="closeNewStudentModal"
                :account="account"
                :gradesSetup="gradesSetup"
            ></new-student> -->
        </v-dialog>
    </div>
</template>
<script>
import { groupBy, onlyUnique, getDomain, sum } from "../../utils/helpers.js";
// import newStudent from "./newStudent.vue";
import { loadOptions } from "../../utils/smLookup.js";

export default {
    props: {
        students: Array,
        classes: Array,
        dates: Array,
        gradesSetup: Array,
        account: Object,
        charges: Array,
    },
    // components: {
    //     "new-student": newStudent,
    // },
    data() {
        return {
            editingStudent: "",
            newStudentDialog: false,
            insuranceCompanies: [],

            rules: {
                required: (value, duration) => {
                    return duration == "NONE" || !!value || "Required.";
                },
            },
        };
    },
    async created() {
        await this.loadInsuranceCompanies();
    },
    computed: {},
    methods: {
        async loadInsuranceCompanies() {
            this.insuranceCompanies = await loadOptions("InsuranceCompany");
        },
        getWeekProperty(index) {
            const weekNumber = 1 + index;

            return "week" + weekNumber;
        },
        validate() {
            // const validations = this.students.map((student, index) =>
            //     this.$refs.chosenClass[index].validate(true)
            // );

            // return validations.every(Boolean);

            return true;
        },
        resetPrice(student) {
            student.paymentAmount = student.price();

            student.charges.forEach((charge) => {
                const original = this.charges.find(
                    (c) => c.name == charge.name
                );

                charge.paymentAmount = original.amount;
            });

            this.updateTotal(student);
        },
        getPaymentAmount(student) {
            return student.paymentAmount || student.price();
        },
        getStudentTotal(student) {
            const charges = sum(student.charges.map((c) => +c.paymentAmount));

            return +this.getPaymentAmount(student) + charges;
        },
        edit(student) {
            student.editingAmount = true;
            student.originalAmount = student.paymentAmount || student.price();
            student.paymentAmount = student.paymentAmount || student.price();

            this.updateTotal(student);
        },
        rollback(student) {
            student.paymentAmount = student.originalAmount;
            student.editingAmount = false;
            student.originalAmount = 0;

            this.updateTotal(student);
        },
        closeNewStudentModal() {
            this.newStudentDialog = false;
        },
        onNewStudentCreated(student) {
            const existing = this.students.find(
                (s) => (s.studentID = student.studentID)
            );

            existing.engName = student.engName;
            existing.hebName = student.hebName;
            existing.dob = student.dob;
            existing.class = student.class;

            this.newStudentDialog = false;
        },
        editStudent(student) {
            this.$refs.newStudent.prefill(student);

            this.newStudentDialog = true;
        },
        updateTotal(student, durationUpdated = false) {
            if (student.duration == "NONE") {
                student.total = 0;
                return;
            }

            student.paymentAmount = student.paymentAmount
                ? student.paymentAmount
                : student.price();

            if (durationUpdated) {
                student.paymentAmount = student.price();

                const laundry = student.charges.find(
                    (c) => c.name == "Laundry Fee"
                );

                const originalLaundry = this.charges.find(
                    (c) => c.name == "Laundry Fee"
                );

                if (laundry) {
                    laundry.paymentAmount = student.duration.startsWith("HALF")
                        ? originalLaundry.amount / 2
                        : originalLaundry.amount;
                }
            }

            const charges = sum(student.charges.map((c) => +c.paymentAmount));

            student.total = +this.getPaymentAmount(student) + charges;
        },
    },
};
</script>
<style>
.weeks-selection .v-input__slot {
    margin-bottom: 0px !important;
}
</style>
